import React from 'react';
import FlexBox from '@components/layout/FlexBox';

import { TransformAttributesEnhancement } from "@dndModels";

import AttributesEnhancementInput from './AttributesEnhancementInput';
import InheritAttributesEnhancementInput from './InheritAttributesEnhancementInput';

interface Props {
  attributes: TransformAttributesEnhancement;
  disabled: boolean;
  use_creature: boolean;
  onChange: () => void;
}

export default function TransformAttributesEnhancementInput({
  attributes,
  disabled,
  use_creature,
  onChange
}: Props) {
  return (
    <FlexBox direction="column">
      <FlexBox xs_expand={0} className="header centered">Transform Attributes</FlexBox>
      <FlexBox>
        <AttributesEnhancementInput
          value={attributes.attributes}
          disabled={disabled}
          onChange={onChange}
        />
      </FlexBox>
      <FlexBox>
        <InheritAttributesEnhancementInput
          header="Attributes from Target"
          value={attributes.from_target}
          disabled={disabled}
          onChange={onChange}
        />
      </FlexBox>
      { use_creature && 
        <FlexBox>
          <InheritAttributesEnhancementInput
            header="Attributes from Creature"
            value={attributes.from_creature}
            disabled={disabled}
            onChange={onChange}
          />
        </FlexBox>
      }
    </FlexBox>
  );
}
